import src from "IMAGE";
export default { src, width: 373, height: 437, blurWidth: 0, blurHeight: 0};
